import React from 'react';
import './Card.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  headerAction?: React.ReactNode;
  /** none · sm(16) · md(20) · lg(24) */
  padding?: 'none' | 'sm' | 'md' | 'lg';
  /** major = 24px radius 패널, 기본 = 16px 카드 */
  tone?: 'default' | 'major' | 'dark';
  /** @deprecated 디자인 시스템은 hairline 우선 — 무시됩니다 */
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  title,
  subtitle,
  headerAction,
  padding = 'md',
  tone = 'default',
  hover = false,
}) => {
  const classes = [
    'ui-card',
    `ui-card--pad-${padding}`,
    tone !== 'default' && `ui-card--${tone}`,
    hover && 'ui-card--interactive',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {(title || subtitle || headerAction) && (
        <div className="ui-card__header">
          <div>
            {title && <h3 className="ui-card__title">{title}</h3>}
            {subtitle && <p className="ui-card__subtitle">{subtitle}</p>}
          </div>
          {headerAction && <div className="ui-card__action">{headerAction}</div>}
        </div>
      )}
      <div className="ui-card__body">{children}</div>
    </div>
  );
};

export default Card;